// extracted by mini-css-extract-plugin
export var active = "styles-module--active--2ea75";
export var footer = "styles-module--footer--977f0";
export var isScrollHidden = "styles-module--isScrollHidden--61240";
export var menu = "styles-module--menu--1f1cf";
export var ps__railY = "styles-module--ps__rail-y--db590";
export var rotateIcon = "styles-module--rotateIcon--31c9a";
export var sectionLink = "styles-module--sectionLink--8fdf3";
export var sectionLinks = "styles-module--sectionLinks--4ec06";
export var sections = "styles-module--sections--69622";
export var sidebarDefaultBullet = "styles-module--sidebarDefaultBullet--c9a25";
export var sidebarLeafBullet = "styles-module--sidebarLeafBullet--6356f";
export var specialIcon = "styles-module--specialIcon--f8060";